
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12600',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12600",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9751",
  "foundations-components": "static-1.8104",
  "foundations-components-legacy": "static-1.1129",
  "foundations-theming": "static-1.4522",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8107",
  "hub-http-shared-msw-handlers": "static-1.10179",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11564",
  "I18n": "static-7.1634",
  "jasmine-runner": "static-1.6550",
  "marketplace-storefront-base": "static-1.12663",
  "quartz": "static-1.7139",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16771",
  "reactive-variable-buffer-atom": "static-1.2947",
  "reporting-testing-lib": "static-1.9836",
  "settings-ui-lib": "static-1.12609",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7298",
  "ui-addon-i18n": "static-1.11241",
  "ui-addon-react-router-dom": "static-1.9630",
  "unified-auth": "static-1.596",
  "unified-auth-core-lib": "static-1.878",
  "usage-tracker": "static-1.7438",
  "usage-tracker-core": "static-1.7288",
  "customer-data-property-utils": "static-1.8185",
  "hub-http": "static-1.6311",
  "integrations-lib": "static-1.16445",
  "marketplace-ui-common": "static-1.20075",
  "property-management-iframe": "static-1.13463",
  "quartz-config": "static-1.917",
  "quartz-core": "static-1.6358",
  "quartz-routing": "static-1.569",
  "quick-fetch": "static-1.3984",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4745",
  "ts-schema": "static-1.4147",
  "ui-universal-auth": "static-1.9082",
  "UIComponents": "static-3.8510",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3467",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3416",
  "quartz-webpack": "static-1.3363",
  "bend-plugin-quartz-routing": "static-1.217",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4373",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4958",
  "foundations-theming-specialty": "static-1.2238",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9512",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5410",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2159",
  "ui-fonts": "static-1.826",
  "ui-images": "static-2.1174",
  "bend-plugin-foundations-theming": "static-1.3005",
  "foundations-theming-base": "static-1.3507",
  "stylex": "static-1.34",
  "HeadJS": "static-2.766",
  "hs-test-utils-bend-plugin": "static-1.3218",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4415",
  "ai-components-ui-library": "static-1.9177",
  "ai-rendering-library": "static-1.10485",
  "chirp-fetch": "static-1.1977",
  "connections-embed-lib": "static-1.1149",
  "copilot-toolkit": "static-1.11360",
  "feedback-loader": "static-1.29457",
  "laboratory-lib": "static-3.7245",
  "marketplace-embed": "static-1.22368",
  "marketplace-ui-details": "static-1.9970",
  "marketplace-ui-reviews": "static-1.20030",
  "marketplace-ui-tracking": "static-1.14245",
  "sanitize-text": "static-1.8234",
  "ui-addon-video-player": "static-1.8793",
  "usage-tracker-multi": "static-1.5852",
  "usage-tracker-session-replay": "static-1.5124",
  "wootric-nps": "static-1.7049",
  "quartz-head": "static-1.804",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4742",
  "immer": "static-1.33",
  "immerable": "static-1.4244",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2559",
  "reporting-data": "static-1.67903",
  "cssUtils": "static-1.817",
  "flux-actions": "static-1.343",
  "HubStyle": "static-2.11871",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10297",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10453",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7428",
  "icons": "static-2.651",
  "marketplace-ui-apps-core": "static-1.18607",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4602",
  "foundations-components-test-utils": "static-1.5587",
  "quartz-i18n": "static-1.814",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.256",
  "google-sheets-integration-lib": "static-1.500",
  "microsoft-drive-integration-lib": "static-1.638",
  "slack-ui-library": "static-1.10482",
  "fsm": "static-1.3818",
  "customer-data-objects": "static-1.7767",
  "property-translator": "static-1.5485",
  "hs-locale-management": "static-1.148",
  "frontend-preferences-client": "static-1.8016",
  "hs-promise-utils": "static-1.5681",
  "hubspot-apollo-client": "static-1.4967",
  "integrations-error-boundary-lib": "static-1.13860",
  "integrations-tracking-lib": "static-1.5696",
  "native-integrations-shared-strings": "static-1.7871",
  "reselect": "static-2.16",
  "sanitize": "static-1.4566",
  "superstore": "static-1.4849",
  "ui-shepherd-react": "static-3.10312",
  "ai-settings-ui-library": "static-1.8026",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4718",
  "immutable-less": "static-1.4743",
  "marketplace-ui-client-types": "static-1.17482",
  "nav-meta": "static-1.29877",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10337",
  "ui-addon-upgrades": "static-9.18116",
  "inbound-db-properties-service-client": "static-1.3912",
  "property-management-common": "static-1.5751",
  "ui-addon-iframeable": "static-1.9152",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.814",
  "quartz-test": "static-1.814",
  "quartz-tracking": "static-1.518",
  "trellis-components": "static-1.2178",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.155",
  "bender-build-tools": "static-1.3278",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21721",
  "ContentUtils": "static-1.68610",
  "customer-data-objects-ui-components": "static-1.13121",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.285",
  "breeze-onboarding-components": "static-1.180",
  "avatar-components": "static-1.2587",
  "customer-data-filters-ui": "static-1.40096",
  "customer-data-reference-ui-components": "static-1.13259",
  "embedded-academy-lib": "static-1.14598",
  "ExportDialog": "static-6.10472",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41522",
  "reporting-snowflake": "static-1.56521",
  "reporting-ui-components": "static-2.65174",
  "reporting-visualizations": "static-1.59979",
  "ui-addon-teams": "static-1.21668",
  "integrations-reconnect-lib": "static-1.122",
  "magpie-lib": "static-1.5610",
  "navigation-components": "static-1.18240",
  "breeze-engine-lib": "static-1.1007",
  "magpie-types": "static-1.5070",
  "simple-logging-lib": "static-1.3140",
  "ai-studio-lib": "static-1.11872",
  "app-governance-lib": "static-1.1833",
  "developer-experience-shared-components": "static-1.10603",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8094",
  "ui-product-approvals": "static-1.28521",
  "ui-tool-access": "static-1.10237",
  "usage-based-billing-components-lib": "static-1.9333",
  "usage-tracker-anonymous": "static-1.5855",
  "usage-tracker-public": "static-1.7249",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3653",
  "persist-promise": "static-1.3789",
  "reference-resolvers": "static-1.8264",
  "ui-extensibility-client-types": "static-1.4014",
  "hubspot-apollo-cache": "static-1.426",
  "universal-page-editor-lib": "static-1.3107",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3030",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5164",
  "purchase-motions-components": "static-1.6054",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1632",
  "crm-component-utils": "static-1.39318",
  "crm-properties-common-lib": "static-1.5978",
  "customer-data-properties": "static-1.51889",
  "framework-data-schema-resolvers": "static-1.6979",
  "property-value-citations": "static-1.2503",
  "reference-resolvers-lite": "static-1.8188",
  "ui-business-units-lib": "static-1.9150",
  "navigation-messaging": "static-1.7567",
  "hubspotter-http-shared-msw-handlers": "static-1.10177",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1029",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4902",
  "content-icons-ui": "static-1.2251",
  "customer-data-ui-utilities": "static-1.9915",
  "conversations-skeleton-state": "static-1.7339",
  "crm-message-bus": "static-1.43212",
  "customer-data-filters-ui-msw-helpers": "static-1.22531",
  "events-data-lib": "static-1.320",
  "FormUrlGenerator": "static-2.4811",
  "framework-builder-read-service-client": "static-1.4072",
  "framework-data-schema-quick-fetch": "static-1.6884",
  "multi-account-reference-resolvers": "static-1.1071",
  "onboarding-tours": "static-1.16764",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13931",
  "academy-common-lib": "static-1.14058",
  "content-assistance-lib": "static-1.7891",
  "dashboard-lib": "static-1.81878",
  "file-manager-components": "static-1.23844",
  "getting-started-shared-tasks": "static-1.18659",
  "hubspot-prosemirror": "static-1.18475",
  "hubspot-prosemirror-plugins": "static-1.18467",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19977",
  "share-with-third-party-component-lib": "static-1.8794",
  "ui-addon-draggable": "static-3.4852",
  "ui-asset-management-lib": "static-1.11149",
  "user-context": "static-1.5199",
  "growth-payments-core": "static-1.25639",
  "reporting-plugins": "static-1.10474",
  "reporting-reports": "static-1.67581",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.815",
  "nest": "static-1.321",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10717",
  "framework-listing-lib": "static-2.28942",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30927",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4341",
  "react-dnd-compat": "static-1.4703",
  "ui-product-approvals-common": "static-1.416",
  "onboarding-scopes": "static-1.6551",
  "onboarding-tours-client": "static-1.4978",
  "platform-infra-nav-components": "static-1.7740",
  "subscription-experience-data-types": "static-1.15045",
  "crm-record-cards-service-types": "static-1.3657",
  "location-customization-utils-lib": "static-1.9519",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6057",
  "signup-constants": "static-1.19046",
  "signup-ui-url-generator": "static-2.8145",
  "card-properties-lib": "static-1.44462",
  "commerce-subscription-lib": "static-1.37381",
  "crm-actions": "static-1.6429",
  "crm-cards-sdk": "static-1.43844",
  "customer-data-properties-shared-msw-handlers": "static-1.9506",
  "customer-data-tracking": "static-1.6979",
  "hs-resources": "static-1.264",
  "pulse": "static-1.686",
  "calling-global-api": "static-1.64820",
  "calling-internal-common": "static-1.31398",
  "calling-lifecycle-internal": "static-1.66202",
  "calling-lifecycle-messages": "static-1.58496",
  "commerce-products-lib": "static-1.9868",
  "conditional-properties-service-client": "static-1.3864",
  "crm-links": "static-1.6396",
  "crm-pipelines-api-client-types": "static-1.4205",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4288",
  "meetings-icalendar-utils-lib": "static-1.723",
  "multi-currency-client-types": "static-1.3758",
  "object-builder-ui-client": "static-1.49053",
  "pipeline-validation-client-types": "static-1.4033",
  "smart-property-lib": "static-1.7628",
  "tiered-pricing": "static-1.1413",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11079",
  "fdsr-migration-layer": "static-1.98",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1098",
  "growth-data-modal": "static-1.5568",
  "growth-onboarding-confetti": "static-1.3156",
  "growth-onboarding-next-action-utils": "static-1.2180",
  "onboarding-tours-utils": "static-1.830",
  "ui-shepherd-tracker": "static-1.7693",
  "academy-service-client": "static-1.3773",
  "SafeStorage": "static-1.4488",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39343",
  "FileManagerLib": "static-1.39484",
  "video-embed": "static-1.36058",
  "ui-coaching-tips": "static-1.28809",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11566",
  "video-data-lib": "static-1.35224",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8554",
  "payment-link-components": "static-1.23747",
  "ui-addon-emoji-picker": "static-1.9977",
  "EmailSignatureEditor": "static-1.24564",
  "viral-links-lib": "static-1.7158",
  "data-token-picker": "static-1.16558",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.315",
  "timezone-utils": "static-2.5333",
  "seat-types-lib": "static-1.221",
  "getting-started-shared-tasks-store": "static-1.17777",
  "ui-addon-opt": "static-4.8450",
  "campaign-roi-lib": "static-1.9349",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25628",
  "framework-data-table": "static-2.12111",
  "marketing-platform-lib": "static-1.6953",
  "nudge-client-utils": "static-1.2763",
  "nudge-custom-ui-functions": "static-1.1186",
  "switchboard-lib": "static-1.312",
  "app-users-service-client": "static-1.5696",
  "app-users-service-types": "static-1.5104",
  "mini-checkout-client": "static-1.27002",
  "onboarding-utils": "static-1.5450",
  "permissions-shared-i18n-strings-fe": "static-1.2058",
  "ui-coaching-tips-shared-config": "static-1.28794",
  "edison-service-client-types": "static-1.479",
  "crm_data": "static-4.92252",
  "customer-data-sidebar": "static-2.46257",
  "enrichment-properties-lib": "static-1.16746",
  "ui-addon-draggable-compat": "static-2.4349",
  "universal-record-utils-lib": "static-1.1165",
  "commerce-billing-lib": "static-1.19358",
  "commerce-shared-components-lib": "static-1.18735",
  "commerce-tools-ui-lib": "static-1.10605",
  "crm-fe-perf": "static-1.22993",
  "event-emitter": "static-1.1038",
  "bend-plugin-pulse": "static-1.189",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31405",
  "shared-worker-versioning": "static-1.11125",
  "calling-usage-tracker": "static-1.6632",
  "voice-sms-access-library": "static-1.1335",
  "commerce-permissions": "static-1.866",
  "products-iframe-lib": "static-1.8168",
  "products-ui-components-shared-msw-handlers": "static-1.10561",
  "data-agent-kit": "static-1.334",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10262",
  "policy-lib": "static-1.6869",
  "react-tinymce": "static-1.55477",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10325",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54603",
  "tinymce-plugins": "static-1.57717",
  "tinymce-themes": "static-1.56573",
  "onboarding-data-sync-lib": "static-1.2112",
  "growth-onboarding-next-action-components": "static-1.2208",
  "user-context-client": "static-1.4678",
  "audio-components": "static-1.6049",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36995",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4626",
  "video-components": "static-1.13568",
  "outpost": "static-1.4260",
  "growth-onboarding-feedback-components": "static-1.6669",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "media-bridge-lib": "static-1.19075",
  "commerce-tours-lib": "static-1.6262",
  "growth-onboarding-reliability": "static-1.5170",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21826",
  "sales-email-signature-service-client": "static-1.3938",
  "ts-utils-lib": "static-1.262",
  "crm-export-dialog": "static-1.6377",
  "crm-index-associations-lib": "static-1.6533",
  "crm-view-components": "static-1.540",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7419",
  "nudge-custom-function-registry": "static-1.2520",
  "nudge-renderer-utils": "static-1.2839",
  "whisper-core-api": "static-1.6817",
  "InboxConnectUtils": "static-4.15044",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5731",
  "settings-content-modals": "static-1.46337",
  "crm_universal": "static-1.22158",
  "customer-data-email": "static-1.18186",
  "card-payment-highlight-lib": "static-1.37427",
  "card-subscription-highlight-lib": "static-1.39804",
  "commerce-contract-lib": "static-1.12508",
  "invoices-highlight-card-lib": "static-1.54999",
  "orders-highlight-card-lib": "static-1.21711",
  "products-highlight-card-lib": "static-1.18151",
  "quotes-highlight-card-lib": "static-1.72322",
  "crm-source-interpretation-lib": "static-1.5433",
  "crm-object-search-query-utilities": "static-1.9775",
  "utility-belt": "static-1.2622",
  "payments-enrollment-embed-lib": "static-1.23158",
  "stripe-embedded-components": "static-1.7660",
  "customer-data-rte": "static-1.33225",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5895",
  "payments-post-enroll-local-storage-lib": "static-1.5197",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38412",
  "trials-service-types": "static-1.3969",
  "calling-orchestration-schema": "static-1.36112",
  "sales-views-client-types": "static-1.4348",
  "hub-http-contrib": "static-1.3131",
  "interframe": "static-3.4849",
  "tinymce-data": "static-1.40688",
  "ui-addon-sales-email": "static-1.5300",
  "layout-dnd-components": "static-1.12609",
  "layout-dnd-utils": "static-1.11584",
  "ui-brand-identity-lib": "static-1.15590",
  "NamespacedHubStyle": "static-2.9125",
  "meetings-connect-utils-lib": "static-1.7694",
  "social-insights-client-types": "static-1.22298",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4250",
  "checkout-sdk": "static-3.23845",
  "checkout-service-types": "static-1.3867",
  "company-details-components": "static-1.6287",
  "payment-method-components": "static-1.6970",
  "pricing-pages-ui-components": "static-1.14562",
  "quote-checkout-service-types": "static-1.3555",
  "upgrade-catalog-service-types": "static-1.3610",
  "access-control-lib": "static-1.10524",
  "EmailComponents": "static-1.55011",
  "EmailData": "static-1.53688",
  "redux-less": "static-2.9573",
  "sequences-lib": "static-1.8194",
  "ui-gdpr-components": "static-1.10440",
  "products-ui-components": "static-1.40386",
  "accounting-integrations-ui-components": "static-1.7204",
  "invoices-ui-lib": "static-1.55015",
  "commerce-products-api": "static-1.2421",
  "invoices-iframe-lib": "static-1.57073",
  "quotes-modal-lib": "static-1.103000",
  "quotes-ui-lib": "static-1.81043",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28496",
  "ContentData": "static-1.68685",
  "layout-data-lib": "static-1.9909",
  "hub-http-rxjs": "static-1.807",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4028",
  "billing-payments-client-types": "static-1.4081",
  "react-performance-metrics-lib": "static-1.646",
  "account-and-billing-fintech-outages": "static-3.18699",
  "pricing-pages-api": "static-1.14427",
  "ContentComponents": "static-2.71566",
  "marketing-contacts-lib": "static-1.10350",
  "marketing-email-service-types": "static-1.1970",
  "messaging-editing-lib": "static-1.46521",
  "messaging-usage-based-billing-components-lib": "static-1.1383",
  "automation-ui-source-apps": "static-1.19138",
  "automation-ui-types": "static-1.20056",
  "messaging-types-lib": "static-1.46258",
  "onboarding-settings-client": "static-1.4594",
  "sequences-client-types-lib": "static-1.8051",
  "commerce-tax-lib": "static-1.625",
  "price-books-api": "static-1.1158",
  "price-books-components": "static-1.1216",
  "property-description-translator": "static-1.3929",
  "ramp-editor": "static-1.347",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23838",
  "SalesContentIndexUI": "static-3.9371",
  "advanced-menus-core": "static-1.15269",
  "advanced-menus-lib": "static-1.12186",
  "ui-memberships-settings-lib": "static-1.34284",
  "segments-query-core": "static-1.1507",
  "eligibility-engine-service-types": "static-1.3250",
  "automation-ui-ubb": "static-1.5972",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7428",
  "data-token-views": "static-1.16539",
  "forms-utils-lib": "static-1.12745",
  "payments-embed-points-lib": "static-1.13211",
  "simple-menus-core": "static-1.15268",
  "simple-menus-lib": "static-1.16785",
  "videoconference-integration-components": "static-1.6943",
  "marketing-contacts-client": "static-1.7604",
  "automation-applications-service-types": "static-1.3593",
  "automation-platform-service-types": "static-1.2626",
  "ContentEditorUI": "static-2.77352",
  "short-messages-app-service-client": "static-1.4029",
  "web-interactives-components": "static-1.13909",
  "web-interactives-data": "static-1.13910",
  "messaging-shared-utils-lib": "static-1.832",
  "messaging-user-info-utils-lib": "static-1.1002",
  "email-portal-health-service-types": "static-1.1069",
  "line-items-api": "static-1.823",
  "commerce-totals-service-types": "static-1.3886",
  "FireAlarmUi": "static-1.4578",
  "sales-templates-service-types-lib": "static-1.4237",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21992",
  "automation-ui-usage-tracking": "static-1.21455",
  "data-studio-ubb": "static-1.2975",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27219",
  "collaboration-sidebar": "static-1.58085",
  "content-management-data-lib": "static-1.5543",
  "copilot-plugins": "static-1.11333",
  "cta-picker": "static-1.36637",
  "customer-agent-discovery-components-lib": "static-1.3334",
  "editor-components": "static-1.13352",
  "editor-iframe-lib": "static-1.8522",
  "error-messaging-js": "static-1.5282",
  "FormsCommonComponents": "static-1.86102",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10736",
  "SharedLegalStrings": "static-1.1835",
  "smart-content-core": "static-1.42680",
  "smart-content-lib": "static-1.43333",
  "social-composer-lib": "static-1.59476",
  "structured-content-lib": "static-1.25422",
  "theme-previewer-lib": "static-1.53482",
  "tinymce-copilot": "static-1.16671",
  "xray-recommendation-lib": "static-1.8024",
  "automation-ui-routing": "static-1.21413",
  "sql-reporting-client-types": "static-1.5713",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42381",
  "campaigns-utils-lib": "static-1.3278",
  "reporting-enablement": "static-1.23235",
  "chatspot-widget-iframe": "static-1.21712",
  "collaboration-sidebar-common": "static-1.2882",
  "forms-ai-lib": "static-1.4456",
  "codemirror-dlb": "static-1.58911",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6523",
  "report-customization-components": "static-1.13387",
  "data-quality-ui-library": "static-1.13263",
  "reporting-filters": "static-1.540",
  "reporting-insights-lib": "static-1.2006"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12600",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9751",
  "foundations-components": "/foundations-components/static-1.8104",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1129",
  "foundations-theming": "/foundations-theming/static-1.4522",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8107",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10179",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11564",
  "I18n": "/I18n/static-7.1634",
  "jasmine-runner": "/jasmine-runner/static-1.6550",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12663",
  "quartz": "/quartz/static-1.7139",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16771",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2947",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9836",
  "settings-ui-lib": "/settings-ui-lib/static-1.12609",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7298",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11241",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9630",
  "unified-auth": "/unified-auth/static-1.596",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.878",
  "usage-tracker": "/usage-tracker/static-1.7438",
  "usage-tracker-core": "/usage-tracker-core/static-1.7288",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8185",
  "hub-http": "/hub-http/static-1.6311",
  "integrations-lib": "/integrations-lib/static-1.16445",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20075",
  "property-management-iframe": "/property-management-iframe/static-1.13463",
  "quartz-config": "/quartz-config/static-1.917",
  "quartz-core": "/quartz-core/static-1.6358",
  "quartz-routing": "/quartz-routing/static-1.569",
  "quick-fetch": "/quick-fetch/static-1.3984",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4745",
  "ts-schema": "/ts-schema/static-1.4147",
  "ui-universal-auth": "/ui-universal-auth/static-1.9082",
  "UIComponents": "/UIComponents/static-3.8510",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3467",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3416",
  "quartz-webpack": "/quartz-webpack/static-1.3363",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.217",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4373",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4958",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2238",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9512",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5410",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2159",
  "ui-fonts": "/ui-fonts/static-1.826",
  "ui-images": "/ui-images/static-2.1174",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3005",
  "foundations-theming-base": "/foundations-theming-base/static-1.3507",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.766",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3218",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4415",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9177",
  "ai-rendering-library": "/ai-rendering-library/static-1.10485",
  "chirp-fetch": "/chirp-fetch/static-1.1977",
  "connections-embed-lib": "/connections-embed-lib/static-1.1149",
  "copilot-toolkit": "/copilot-toolkit/static-1.11360",
  "feedback-loader": "/feedback-loader/static-1.29457",
  "laboratory-lib": "/laboratory-lib/static-3.7245",
  "marketplace-embed": "/marketplace-embed/static-1.22368",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9970",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20030",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14245",
  "sanitize-text": "/sanitize-text/static-1.8234",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8793",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5852",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5124",
  "wootric-nps": "/wootric-nps/static-1.7049",
  "quartz-head": "/quartz-head/static-1.804",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4742",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4244",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2559",
  "reporting-data": "/reporting-data/static-1.67903",
  "cssUtils": "/cssUtils/static-1.817",
  "flux-actions": "/flux-actions/static-1.343",
  "HubStyle": "/HubStyle/static-2.11871",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10297",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10453",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7428",
  "icons": "/icons/static-2.651",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18607",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4602",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5587",
  "quartz-i18n": "/quartz-i18n/static-1.814",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.256",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.500",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.638",
  "slack-ui-library": "/slack-ui-library/static-1.10482",
  "fsm": "/fsm/static-1.3818",
  "customer-data-objects": "/customer-data-objects/static-1.7767",
  "property-translator": "/property-translator/static-1.5485",
  "hs-locale-management": "/hs-locale-management/static-1.148",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8016",
  "hs-promise-utils": "/hs-promise-utils/static-1.5681",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4967",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13860",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5696",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7871",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4566",
  "superstore": "/superstore/static-1.4849",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10312",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8026",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4718",
  "immutable-less": "/immutable-less/static-1.4743",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17482",
  "nav-meta": "/nav-meta/static-1.29877",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10337",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18116",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3912",
  "property-management-common": "/property-management-common/static-1.5751",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9152",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.814",
  "quartz-test": "/quartz-test/static-1.814",
  "quartz-tracking": "/quartz-tracking/static-1.518",
  "trellis-components": "/trellis-components/static-1.2178",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.155",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21721",
  "ContentUtils": "/ContentUtils/static-1.68610",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13121",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.285",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.180",
  "avatar-components": "/avatar-components/static-1.2587",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40096",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13259",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14598",
  "ExportDialog": "/ExportDialog/static-6.10472",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41522",
  "reporting-snowflake": "/reporting-snowflake/static-1.56521",
  "reporting-ui-components": "/reporting-ui-components/static-2.65174",
  "reporting-visualizations": "/reporting-visualizations/static-1.59979",
  "ui-addon-teams": "/ui-addon-teams/static-1.21668",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.122",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "navigation-components": "/navigation-components/static-1.18240",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1007",
  "magpie-types": "/magpie-types/static-1.5070",
  "simple-logging-lib": "/simple-logging-lib/static-1.3140",
  "ai-studio-lib": "/ai-studio-lib/static-1.11872",
  "app-governance-lib": "/app-governance-lib/static-1.1833",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10603",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8094",
  "ui-product-approvals": "/ui-product-approvals/static-1.28521",
  "ui-tool-access": "/ui-tool-access/static-1.10237",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9333",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5855",
  "usage-tracker-public": "/usage-tracker-public/static-1.7249",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3653",
  "persist-promise": "/persist-promise/static-1.3789",
  "reference-resolvers": "/reference-resolvers/static-1.8264",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4014",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.426",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3107",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3030",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5164",
  "purchase-motions-components": "/purchase-motions-components/static-1.6054",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1632",
  "crm-component-utils": "/crm-component-utils/static-1.39318",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5978",
  "customer-data-properties": "/customer-data-properties/static-1.51889",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6979",
  "property-value-citations": "/property-value-citations/static-1.2503",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8188",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9150",
  "navigation-messaging": "/navigation-messaging/static-1.7567",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10177",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1029",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4902",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9915",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7339",
  "crm-message-bus": "/crm-message-bus/static-1.43212",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22531",
  "events-data-lib": "/events-data-lib/static-1.320",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4811",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4072",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6884",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1071",
  "onboarding-tours": "/onboarding-tours/static-1.16764",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13931",
  "academy-common-lib": "/academy-common-lib/static-1.14058",
  "content-assistance-lib": "/content-assistance-lib/static-1.7891",
  "dashboard-lib": "/dashboard-lib/static-1.81878",
  "file-manager-components": "/file-manager-components/static-1.23844",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18659",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18475",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18467",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19977",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8794",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4852",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11149",
  "user-context": "/user-context/static-1.5199",
  "growth-payments-core": "/growth-payments-core/static-1.25639",
  "reporting-plugins": "/reporting-plugins/static-1.10474",
  "reporting-reports": "/reporting-reports/static-1.67581",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.815",
  "nest": "/nest/static-1.321",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10717",
  "framework-listing-lib": "/framework-listing-lib/static-2.28942",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30927",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4341",
  "react-dnd-compat": "/react-dnd-compat/static-1.4703",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.416",
  "onboarding-scopes": "/onboarding-scopes/static-1.6551",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4978",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7740",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15045",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3657",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9519",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6057",
  "signup-constants": "/signup-constants/static-1.19046",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8145",
  "card-properties-lib": "/card-properties-lib/static-1.44462",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37381",
  "crm-actions": "/crm-actions/static-1.6429",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43844",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9506",
  "customer-data-tracking": "/customer-data-tracking/static-1.6979",
  "hs-resources": "/hs-resources/static-1.264",
  "pulse": "/pulse/static-1.686",
  "calling-global-api": "/calling-global-api/static-1.64820",
  "calling-internal-common": "/calling-internal-common/static-1.31398",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66202",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58496",
  "commerce-products-lib": "/commerce-products-lib/static-1.9868",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3864",
  "crm-links": "/crm-links/static-1.6396",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4205",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4288",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.723",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49053",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4033",
  "smart-property-lib": "/smart-property-lib/static-1.7628",
  "tiered-pricing": "/tiered-pricing/static-1.1413",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11079",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.98",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1098",
  "growth-data-modal": "/growth-data-modal/static-1.5568",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3156",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2180",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.830",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7693",
  "academy-service-client": "/academy-service-client/static-1.3773",
  "SafeStorage": "/SafeStorage/static-1.4488",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39343",
  "FileManagerLib": "/FileManagerLib/static-1.39484",
  "video-embed": "/video-embed/static-1.36058",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28809",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11566",
  "video-data-lib": "/video-data-lib/static-1.35224",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8554",
  "payment-link-components": "/payment-link-components/static-1.23747",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9977",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24564",
  "viral-links-lib": "/viral-links-lib/static-1.7158",
  "data-token-picker": "/data-token-picker/static-1.16558",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.315",
  "timezone-utils": "/timezone-utils/static-2.5333",
  "seat-types-lib": "/seat-types-lib/static-1.221",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17777",
  "ui-addon-opt": "/ui-addon-opt/static-4.8450",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9349",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25628",
  "framework-data-table": "/framework-data-table/static-2.12111",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6953",
  "nudge-client-utils": "/nudge-client-utils/static-1.2763",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1186",
  "switchboard-lib": "/switchboard-lib/static-1.312",
  "app-users-service-client": "/app-users-service-client/static-1.5696",
  "app-users-service-types": "/app-users-service-types/static-1.5104",
  "mini-checkout-client": "/mini-checkout-client/static-1.27002",
  "onboarding-utils": "/onboarding-utils/static-1.5450",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2058",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28794",
  "edison-service-client-types": "/edison-service-client-types/static-1.479",
  "crm_data": "/crm_data/static-4.92252",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46257",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16746",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4349",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1165",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19358",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18735",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10605",
  "crm-fe-perf": "/crm-fe-perf/static-1.22993",
  "event-emitter": "/event-emitter/static-1.1038",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.189",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31405",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11125",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6632",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1335",
  "commerce-permissions": "/commerce-permissions/static-1.866",
  "products-iframe-lib": "/products-iframe-lib/static-1.8168",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10561",
  "data-agent-kit": "/data-agent-kit/static-1.334",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10262",
  "policy-lib": "/policy-lib/static-1.6869",
  "react-tinymce": "/react-tinymce/static-1.55477",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10325",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54603",
  "tinymce-plugins": "/tinymce-plugins/static-1.57717",
  "tinymce-themes": "/tinymce-themes/static-1.56573",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2112",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2208",
  "user-context-client": "/user-context-client/static-1.4678",
  "audio-components": "/audio-components/static-1.6049",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36995",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4626",
  "video-components": "/video-components/static-1.13568",
  "outpost": "/outpost/static-1.4260",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6669",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "media-bridge-lib": "/media-bridge-lib/static-1.19075",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6262",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5170",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21826",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3938",
  "ts-utils-lib": "/ts-utils-lib/static-1.262",
  "crm-export-dialog": "/crm-export-dialog/static-1.6377",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6533",
  "crm-view-components": "/crm-view-components/static-1.540",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7419",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2520",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2839",
  "whisper-core-api": "/whisper-core-api/static-1.6817",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15044",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5731",
  "settings-content-modals": "/settings-content-modals/static-1.46337",
  "crm_universal": "/crm_universal/static-1.22158",
  "customer-data-email": "/customer-data-email/static-1.18186",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37427",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39804",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12508",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54999",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21711",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18151",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72322",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5433",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9775",
  "utility-belt": "/utility-belt/static-1.2622",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23158",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7660",
  "customer-data-rte": "/customer-data-rte/static-1.33225",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5895",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5197",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38412",
  "trials-service-types": "/trials-service-types/static-1.3969",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36112",
  "sales-views-client-types": "/sales-views-client-types/static-1.4348",
  "hub-http-contrib": "/hub-http-contrib/static-1.3131",
  "interframe": "/interframe/static-3.4849",
  "tinymce-data": "/tinymce-data/static-1.40688",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5300",
  "layout-dnd-components": "/layout-dnd-components/static-1.12609",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11584",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15590",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9125",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7694",
  "social-insights-client-types": "/social-insights-client-types/static-1.22298",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4250",
  "checkout-sdk": "/checkout-sdk/static-3.23845",
  "checkout-service-types": "/checkout-service-types/static-1.3867",
  "company-details-components": "/company-details-components/static-1.6287",
  "payment-method-components": "/payment-method-components/static-1.6970",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14562",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3555",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3610",
  "access-control-lib": "/access-control-lib/static-1.10524",
  "EmailComponents": "/EmailComponents/static-1.55011",
  "EmailData": "/EmailData/static-1.53688",
  "redux-less": "/redux-less/static-2.9573",
  "sequences-lib": "/sequences-lib/static-1.8194",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10440",
  "products-ui-components": "/products-ui-components/static-1.40386",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7204",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55015",
  "commerce-products-api": "/commerce-products-api/static-1.2421",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57073",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103000",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81043",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28496",
  "ContentData": "/ContentData/static-1.68685",
  "layout-data-lib": "/layout-data-lib/static-1.9909",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.807",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4028",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4081",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.646",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18699",
  "pricing-pages-api": "/pricing-pages-api/static-1.14427",
  "ContentComponents": "/ContentComponents/static-2.71566",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10350",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1970",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46521",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1383",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19138",
  "automation-ui-types": "/automation-ui-types/static-1.20056",
  "messaging-types-lib": "/messaging-types-lib/static-1.46258",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4594",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8051",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.625",
  "price-books-api": "/price-books-api/static-1.1158",
  "price-books-components": "/price-books-components/static-1.1216",
  "property-description-translator": "/property-description-translator/static-1.3929",
  "ramp-editor": "/ramp-editor/static-1.347",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23838",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9371",
  "advanced-menus-core": "/advanced-menus-core/static-1.15269",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12186",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34284",
  "segments-query-core": "/segments-query-core/static-1.1507",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3250",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5972",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7428",
  "data-token-views": "/data-token-views/static-1.16539",
  "forms-utils-lib": "/forms-utils-lib/static-1.12745",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13211",
  "simple-menus-core": "/simple-menus-core/static-1.15268",
  "simple-menus-lib": "/simple-menus-lib/static-1.16785",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6943",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7604",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3593",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2626",
  "ContentEditorUI": "/ContentEditorUI/static-2.77352",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4029",
  "web-interactives-components": "/web-interactives-components/static-1.13909",
  "web-interactives-data": "/web-interactives-data/static-1.13910",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.832",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1002",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1069",
  "line-items-api": "/line-items-api/static-1.823",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3886",
  "FireAlarmUi": "/FireAlarmUi/static-1.4578",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4237",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21992",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21455",
  "data-studio-ubb": "/data-studio-ubb/static-1.2975",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27219",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58085",
  "content-management-data-lib": "/content-management-data-lib/static-1.5543",
  "copilot-plugins": "/copilot-plugins/static-1.11333",
  "cta-picker": "/cta-picker/static-1.36637",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3334",
  "editor-components": "/editor-components/static-1.13352",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8522",
  "error-messaging-js": "/error-messaging-js/static-1.5282",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86102",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10736",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1835",
  "smart-content-core": "/smart-content-core/static-1.42680",
  "smart-content-lib": "/smart-content-lib/static-1.43333",
  "social-composer-lib": "/social-composer-lib/static-1.59476",
  "structured-content-lib": "/structured-content-lib/static-1.25422",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53482",
  "tinymce-copilot": "/tinymce-copilot/static-1.16671",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8024",
  "automation-ui-routing": "/automation-ui-routing/static-1.21413",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5713",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42381",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3278",
  "reporting-enablement": "/reporting-enablement/static-1.23235",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21712",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2882",
  "forms-ai-lib": "/forms-ai-lib/static-1.4456",
  "codemirror-dlb": "/codemirror-dlb/static-1.58911",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6523",
  "report-customization-components": "/report-customization-components/static-1.13387",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13263",
  "reporting-filters": "/reporting-filters/static-1.540",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2006"
}
};
